module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms2_m.e5754a0dff3215c97bd187ddc9f4ddf4.png";